import { loadable } from "components/SpruceLoader";

export const TaskQueue = loadable(() => import("./taskQueue/index"));
